import { FormControl, FormGroup, FormLabel, MenuItem, OutlinedInput, Select } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIssuers } from '../../store/action_creators/paymentMethods.actions';
import { UserTypeEnum } from '../../store/config/enums';
import { PaymentsFilters, RootState } from '../../store/config/types';
import type { SelectChangeEvent } from '@mui/material/Select';
import { useTheme ,Theme } from '@mui/material';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      [theme.breakpoints.down('md')]: {
        maxHeight: '50vh',
        overflow: 'auto',
      },
    },
  }),
);

interface IssuerFiltersProps {
  filters: PaymentsFilters | null;
  setFilters: (filters: PaymentsFilters) => void;
  hasDateFilters?: boolean;
}

function IssuerFilters({ filters, setFilters, hasDateFilters }: IssuerFiltersProps) {
  const classes = useStyles(useTheme());
  const dispatch = useDispatch<any>();
  const { paymentMethods, auth } = useSelector((state: RootState) => state);
  const isSuperAdmin = auth.account?.type === UserTypeEnum.SUPERADMIN;
  const issuersToSelect = isSuperAdmin ? paymentMethods.issuers : paymentMethods.paymentMethods;

  useEffect(() => {
    if (
      !paymentMethods.loadingIssuers &&
      paymentMethods.issuers === null &&
      paymentMethods.issuersErrorMessage === null
    ) {
      dispatch(fetchIssuers());
    }
  }, [paymentMethods.loadingIssuers, paymentMethods.issuers, paymentMethods.issuersErrorMessage, dispatch]);

 const handleIssuerChange = (event: SelectChangeEvent<string>) => {
   const value = event.target.value;
   const selectedIssuer = value === '' ? undefined : Number(value);
   const filterIssuer = selectedIssuer === filters?.issuer ? undefined : selectedIssuer;
    setFilters({ ...filters, issuer: filterIssuer });
  };

  return (
    <div className="filter-container">
      <FormControl component="fieldset">
        <FormLabel component="legend" classes={{ root: 'form-label' }} focused={false}>
          Medio de pago
        </FormLabel>
        <FormGroup classes={{ root: 'group' }}>
          <Select<string>
            displayEmpty
            input={<OutlinedInput />}
            className="select"
             onChange={handleIssuerChange}
              value={filters?.issuer !== undefined ? String(filters.issuer) : ''}
            MenuProps={{
              classes: { paper: classes.paper },
              
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
          >
            <MenuItem disabled value="select">
              <em>Selecciona</em>
            </MenuItem>
            <MenuItem value="" className="select-element">
              Todos
            </MenuItem>
           {issuersToSelect &&
                issuersToSelect.map((issuer) => (
                <MenuItem value={String(issuer.issuerId)} key={issuer.issuerId} className="select-element">
                  {'issuer' in issuer ? issuer.issuer : issuer.issuerName}
                </MenuItem>
              ))}
          </Select>
        </FormGroup>
      </FormControl>
    </div>
  );
}

export default IssuerFilters;
